import { render, staticRenderFns } from "./BabySize.vue?vue&type=template&id=2563ad23&scoped=true&"
import script from "./BabySize.vue?vue&type=script&lang=js&"
export * from "./BabySize.vue?vue&type=script&lang=js&"
import style0 from "./BabySize.vue?vue&type=style&index=0&id=2563ad23&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2563ad23",
  null
  
)

export default component.exports